import axios from 'axios';
import {jwtDecode} from "jwt-decode";

//Dev
//const API_BASE_URL = 'http://52.47.175.35:8080';

//Prod
const API_BASE_URL = 'https://reservations-api.greenriver-paris.fr';

class AuthService {
    async login(credentials) {
        return await axios.post(API_BASE_URL + "/login", credentials);
    }

    getToken() {
        return localStorage.getItem("token");
    }

    disconnect(){
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
    }

    decodeToken(token){
        return jwtDecode(token);
    }

    async getUserById(){
        return await axios.post(API_BASE_URL + "/getUserById", {userId: this.decodeToken(this.getToken()).id});
    }

    async clearCache(){
        return await axios.post(API_BASE_URL + "/clearCache", {});
    }

    getUrl(url) {
        return API_BASE_URL + url;
    }

    getAuthHeader(locale) {
        locale = !!locale ? locale : "fr";
        return { headers: { Authorization: 'Bearer ' + this.getToken(),"Accept-Language": locale} };
    }

    getAuthHeaderUpload(locale, progress) {
        locale = !!locale ? locale : "fr";
        return { headers: { Authorization: 'Bearer ' + this.getToken(),"Accept-Language": locale}, progress };
    }
}

export default new AuthService();
